import React, { useEffect, useState } from "react";
import ThumbnailList from "../../components/ThumbnailList";
import {
  addBatchTag,
  deleteContentByID,
  editVideo,
  exportTranscript,
  search,
} from "../../services/contentServices";
import Footer from "../../components/Footer";
import PageRecords from "../../components/PageRecords";
import Pagination from "../../components/Pagination";
import { locale } from "../../utils/LocaleManager";
import TopAppBar from "../../components/TopAppBar";
import { useContentStore } from "../../stores/contentStore";
import ContextMenu from "../../components/ContextMenu";
import SearchLabel from "../../components/SearchLabel";
import DialogBox from "../../components/DialogBox";
import { Box, Card, CardContent, Grid, Stack } from "@mui/material";
import { Bounce, toast } from "react-toastify";
import PlayerDialog from "../../components/PlayerDialog";
import { getVideoByID } from "../../services/contentServices";
import { useNavigate } from "react-router-dom";
import { handleError } from "../../utils/utilFunctions";
import SideFolderContainer from "../../components/SideFolderContainer";
import { useFolderStore } from "../../stores/folderStore";
import ScreenFolderContainer from "../../components/ScreenFolders";
import LabelText from "../../components/LabelText";
import { black, mainFont } from "../../utils/StyleHelpers";
import Breadcrumb from "../../components/BreadCrumb";
import SearchFilter from "../../components/SearchFilter";
import BoxComponent from "../../components/Box";
import TextFieldInput from "../../components/Textfield";
import { BatchAddTag, EditVideo } from "../../models/editDetails";
import MoveVideo from "../../components/MoveVideo";
import FolderContextMenu from "../../components/FolderContextMenu";
import SkeletonThumbnailLoader from "../../components/SkeletonThumbnailLoader";
import SortFilter from "../../components/SortFilter";
import jsonToCsvExport from "json-to-csv-export";

const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGEINDEX = 1;
const DEFAULT_SORT_FIELD = "title";
const DEFAULT_SORT_ORDER = 0;
let errorShowed: any = null;

const MainScreen = () => {
  const {
    setIsLoading,
    searchKeyword,
    searchKeywordTemp,
    selectedThumbnails,
    setSelectedThumbnails,
    isShowDeleteDialog,
    setIsShowDeleteDialog,
    setIsShowDetails,
    isShowRetagDialog,
    setIsShowRetagDialog,
    setIsShowEdit,
    isShowPlayer,
    videoUrl,
    setVideoUrl,
    setIsShowPlayer,
    filterTypes,
    isShowMoveDialog,
    setIsShowMoveDialog,
    selectedFolders,
    setSelectedFolders,
    sortOrder,
    sortField,
  } = useContentStore((state: any) => ({
    setIsLoading: state.setIsLoading,
    searchKeyword: state.searchKeyword,
    searchKeywordTemp: state.searchKeywordTemp,
    selectedThumbnails: state.selectedThumbnails,
    setSelectedThumbnails: state.setSelectedThumbnails,
    isShowDeleteDialog: state.isShowDeleteDialog,
    setIsShowDeleteDialog: state.setIsShowDeleteDialog,
    setIsShowDetails: state.setIsShowDetails,
    isShowRetagDialog: state.isShowRetagDialog,
    setIsShowRetagDialog: state.setIsShowRetagDialog,
    setIsShowEdit: state.setIsShowEdit,
    isShowPlayer: state.isShowPlayer,
    videoUrl: state.videoUrl,
    setVideoUrl: state.setVideoUrl,
    setIsShowPlayer: state.setIsShowPlayer,
    filterTypes: state.filterTypes,
    isShowMoveDialog: state.isShowMoveDialog,
    setIsShowMoveDialog: state.setIsShowMoveDialog,
    selectedFolders: state.selectedFolders,
    setSelectedFolders: state.setSelectedFolders,
    sortOrder: state.sortOrder,
    sortField: state.sortField,
  }));

  const {
    folderId,
    breadcrumbPath,
    isShowFolders,
    isDeleteSuccess,
    isMoveSuccess,
    previousFolderId,
    isShowMoveFolder,
    setSelectedId,
    setIsShowRename,
    setIsShowMoveFolder,
  } = useFolderStore((state: any) => ({
    folderId: state.folderId,
    breadcrumbPath: state.breadcrumbPath,
    isShowFolders: state.isShowFolders,
    isDeleteSuccess: state.isDeleteSuccess,
    isMoveSuccess: state.isMoveSuccess,
    previousFolderId: state.previousFolderId,
    isShowMoveFolder: state.isShowMoveFolder,
    setSelectedId: state.setSelectedId,
    setIsShowRename: state.setIsShowRename,
    setIsShowMoveFolder: state.setIsShowMoveFolder,
  }));

  const [searchList, setSearchList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [pageIndex, setPageIndex] = useState(DEFAULT_PAGEINDEX);
  const [selectedValue, setSelectedValue] = useState(0);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [isShowContext, setIsShowContext] = useState(false);
  const [isShowFolderContext, setIsShowFolderContext] = useState(false);
  const [isShowPlayerScreen, setIsShowPlayerScreen] = useState(false);
  const [isClickedBreadCrumb, setIsClickedBreadCrumb] = useState<any>();
  const [isClickedFolder, setIsClickedFolder] = useState<any>();
  const [isDataEmpty, setIsDataEmpty] = useState(false);
  const [retagValue, setRetagValue] = useState<string>("");
  const [tempVideoTitle, setTempVideoTitle] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);
  const skeletonItems = Array.from({ length: pageSize });
  const isShowRenameDialog = useContentStore(
    (state: any) => state.isShowRenameDialog,
  );
  const setIsShowRenameDialog = useContentStore(
    (state: any) => state.setIsShowRenameDialog,
  );

  const navigate = useNavigate();

  const searchFolderId = folderId === 1 ? null : folderId;

  const fetchData = async (
    pageSize: any,
    pageIndex: any,
    sortOrder: any,
    searchKeyword: any,
    filterTypes: any,
    folderId: any,
    sortField: any,
  ) => {
    const id = folderId === 1 ? null : folderId;

    const searchData = await search(
      pageSize,
      pageIndex,
      sortOrder,
      searchKeyword,
      filterTypes,
      id,
      sortField,
    );
    setIsLoading(false);
    if (searchData.status === 200) {
      const data = searchData.data;
      if (data?.items?.length === 0) {
        setIsDataEmpty(true);
      } else {
        setIsDataEmpty(false);
      }
      setSearchList(data.items);
      setTotalRecords(data.totalCount);
      setTotalPages(data.totalPages);
      setPageIndex(data.pageIndex);
      setPageSize(data.pageSize);
    } else {
      handleError({
        status: searchData.response.status,
        toast,
        errorMessage: `Error: Encountered an error fetching list of video. (CODE: ${searchData.code})`,
        onClose: () => {},
      });
    }
  };

  const onClickPlay = async () => {
    const [selected] = selectedThumbnails;
    const getUrl = await getVideoByID(selected.videoIndexId);
    if (getUrl.status === 200) {
      const data = getUrl.data;
      setVideoUrl(data);
      setIsShowPlayer(true);
    } else {
      setSelectedThumbnails([]);
      handleError({
        status: getUrl.response.status,
        toast,
        errorMessage: "Error: Video might be deleted or not available.",
        onClose: () => (errorShowed = null),
      });
    }
  };

  const onChangePageSize = (event: { target: { value: any } }) => {
    setIsLoading(true);
    setSelectedValue(event.target.value);
    setPageSize(event.target.value);
    setSelectedThumbnails([]);
    setPageIndex(DEFAULT_PAGEINDEX);
  };

  const onChangePageRow = (_event: any, value: number) => {
    setIsLoading(true);
    setSelectedThumbnails([]);
    fetchData(
      pageSize,
      value,
      sortOrder,
      searchKeyword,
      filterTypes,
      folderId,
      sortField,
    );
  };

  const onChangePageIndex = (value: number) => {
    if (totalPages >= value) {
      setIsLoading(true);
      setSelectedThumbnails([]);
      fetchData(
        pageSize,
        value,
        sortOrder,
        searchKeyword,
        filterTypes,
        folderId,
        sortField,
      );
    }
  };

  const isShowFooter = () => totalRecords > DEFAULT_PAGE_SIZE;

  const onClose = () => {
    setIsShowPlayer(false);
    setIsShowPlayerScreen(false);
  };

  const onClickDetails = async () => {
    setIsLoading(true);
    toast.info("Redirecting to details page...", {
      position: "bottom-left",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      pauseOnFocusLoss: false,
      theme: "colored",
      closeButton: false,
    });
    const [selected] = selectedThumbnails;
    const getUrl = await getVideoByID(selected.videoIndexId);
    if (getUrl.status === 200) {
      const data = getUrl.data;
      setVideoUrl(data);
      setIsShowPlayer(true);
      navigate(
        "/details/" +
          selected.videoIndexId +
          (searchKeyword ? "/" + searchKeyword : ""),
      );
      setIsShowDetails(true);
    } else {
      setSelectedThumbnails([]);
      handleError({
        status: getUrl.response.status,
        toast,
        errorMessage: "Error: Video might be deleted or not available.",
        onClose: () => (errorShowed = null),
      });
    }
  };

  const onClickEdit = async () => {
    const [selected] = selectedThumbnails;
    const getUrl = await getVideoByID(selected.videoIndexId);
    if (getUrl.status === 200) {
      const data = getUrl.data;
      setVideoUrl(data);
      navigate("/edit/" + selected.videoIndexId);
      setIsShowEdit(true);
    } else {
      setSelectedThumbnails([]);
      handleError({
        status: getUrl.response.status,
        toast,
        errorMessage: "Error: Video might be deleted or not available.",
        onClose: () => (errorShowed = null),
      });
    }
  };

  const renderDeleteDialog = () => (
    <Box sx={{ width: "100%" }}>
      <Stack spacing={1}>
        {selectedThumbnails.map((thumbnail: any) => (
          <Card key={thumbnail.id} variant="outlined">
            <CardContent sx={{ padding: "1.25rem" }}>
              <Stack direction="row" gap="0.625rem">
                <img
                  src={thumbnail.image}
                  alt={thumbnail.name}
                  style={{
                    height: "auto",
                    width: "2.5rem",
                    borderRadius: "0.25rem",
                    alignSelf: "stretch",
                  }}
                />
                {thumbnail.name}
              </Stack>
            </CardContent>
          </Card>
        ))}
      </Stack>
    </Box>
  );

  const deleteVideos = async () => {
    setIsShowDeleteDialog(false);
    toast.warning(`Processing: Deleting ${selectedThumbnails.length} video/s`, {
      position: "bottom-left",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: true,
      pauseOnFocusLoss: false,
      progress: undefined,
      theme: "colored",
      transition: Bounce,
    });

    const deleted = await Promise.allSettled(
      selectedThumbnails.map((thumbnail: any) =>
        deleteContentByID(thumbnail.videoIndexId),
      ),
    );
    const deleteResult = deleted.filter(
      (result) => result.status === "rejected",
    );
    // No rejection on delete
    if (deleteResult?.length === 0) {
      setSelectedThumbnails([]);
      toast.success("Video Deleted", {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
      onClose();
      setIsLoading(true);
      fetchData(
        pageSize,
        pageIndex,
        sortOrder,
        searchKeyword,
        filterTypes,
        folderId,
        sortField,
      );
      // some deletion failed
    } else {
      setSelectedThumbnails([]);
      toast.error("Error: Encountered an error while deleting video.", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    }
  };

  const onCopyLinks = async () => {
    toast.warning(`Processing: Copying link`, {
      position: "bottom-left",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: true,
      pauseOnFocusLoss: false,
      progress: undefined,
      theme: "colored",
      transition: Bounce,
    });

    const [thumbnail] = selectedThumbnails;
    const copied = await getVideoByID(thumbnail.videoIndexId);

    if (copied.status === 200) {
      navigator.clipboard.writeText(copied.data);
      toast.success("Video Link Copied", {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } else {
      handleError({
        status: copied.response.status,
        toast,
        errorMessage: "Error: Encountered an error while copying link.",
        onClose: () => {},
      });
    }
  };

  const onPlayerError = (e: any) => {
    if (errorShowed !== null || e.code === 7000) return;
    errorShowed = toast.error(
      "Error: Video might be deleted or not available",
      {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: true,
        pauseOnFocusLoss: false,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
        onClose: () => (errorShowed = null),
      },
    );
  };

  const onDownload = () => {
    let toastProcessing = toast.warning(
      "Processing: Generating Download links...",
      {
        position: "bottom-left",
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: true,
        progress: undefined,
        autoClose: false,
        theme: "colored",
        transition: Bounce,
      },
    );

    Promise.allSettled(
      selectedThumbnails.map(async (selected: any) => {
        const getUrl = await getVideoByID(selected.videoIndexId);
        if (getUrl.status === 200) {
          const data = getUrl.data;

          await fetch(data, {
            headers: new Headers({
              Origin: window.location.origin,
            }),
            mode: "cors",
          })
            .then((response) => response.blob())
            .then((blob) => {
              let blobUrl = window.URL.createObjectURL(blob);
              var link = document.createElement("a");
              link.href = blobUrl;
              link.download = selected.name;
              link.click();

              toast.success(
                `Success: Download link generated for: ${selected.name}`,
                {
                  position: "bottom-left",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: false,
                  pauseOnFocusLoss: false,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                  transition: Bounce,
                },
              );
            })
            .catch((e) => {
              toast.error(
                `Error: Encountered issue downloading: ${selected.name}`,
                {
                  position: "bottom-left",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: false,
                  pauseOnFocusLoss: false,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                  transition: Bounce,
                },
              );
            });
        } else {
          handleError({
            status: getUrl.response.status,
            toast,
            errorMessage: "Error: Video might be deleted or not available",
            onClose: () => {},
          });
        }
      }),
    ).then(() => toast.dismiss(toastProcessing));
  };

  const renderRetagDialog = () => {
    return (
      <TextFieldInput
        value={retagValue}
        onChange={(e: any) => setRetagValue(e.target.value)}
        autoFocus={true}
      />
    );
  };

  const onRetag = async () => {
    setIsLoading(true);
    setIsShowRetagDialog(false);
    const requestBody: BatchAddTag = {
      videoIndexIds: selectedThumbnails.map((thumb: any) => thumb.videoIndexId),
      tag: retagValue,
    };
    const batchTagResponse = await addBatchTag(requestBody);
    const selectedCount = selectedThumbnails.length;
    const message =
      selectedCount > 1
        ? locale.success_retag_multiple.replace("%d", selectedCount)
        : locale.success_retag;
    setIsLoading(false);
    setRetagValue("");
    if (batchTagResponse.status === 200) {
      setSelectedThumbnails([]);
      toast.success(message, {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
      setIsLoading(true);
      fetchData(
        pageSize,
        pageIndex,
        sortOrder,
        searchKeyword,
        filterTypes,
        folderId,
        sortField,
      );
    } else {
      setSelectedThumbnails([]);
      handleError({
        status: batchTagResponse.response.status,
        toast,
        errorMessage: `Error: Encountered an error batch tagging. (CODE: ${batchTagResponse.code})`,
        onClose: () => {},
      });
    }
  };

  const fetchFolderData = async (id: any) => {
    await fetchData(
      pageSize,
      pageIndex,
      sortOrder,
      searchKeyword,
      filterTypes,
      id,
      sortField,
    );
  };

  const onRenameFolder = () => {
    const [folder] = selectedFolders;
    setSelectedId(folder.id);
    setIsShowRename(true);
  };

  const onRenameVideo = () => {
    setTempVideoTitle(selectedThumbnails[0].name);
    setIsShowRenameDialog(true);
  };

  const editVideoService = async (
    editVideoRequest: EditVideo,
    successMessage: string,
  ) => {
    const requestEditVideo = await editVideo(editVideoRequest);

    if (requestEditVideo.status === 200) {
      setSelectedThumbnails([]);
      setRefreshKey((prev) => prev + 1);
      toast.success(successMessage, {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
        onClose: () => {},
      });
    } else {
      handleError({
        status: requestEditVideo.response.status,
        toast,
        errorMessage: `Error: Encountered an error. (CODE: ${requestEditVideo.code})`,
        onClose: () => {},
      });
    }
  };

  const onSubmitRename = async () => {
    const editVideoRequest: EditVideo = {
      videoIndexId: selectedThumbnails[0].videoIndexId,
      name: tempVideoTitle,
      description: tempVideoTitle,
      newTags: [],
      editTags: [],
      deleteTags: [],
    };

    setIsShowRenameDialog(false);
    toast.warn(locale.cannot_cancel_saving, {
      position: "bottom-left",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      pauseOnFocusLoss: false,
      draggable: true,
      progress: undefined,
      theme: "colored",
      transition: Bounce,
    });
    await editVideoService(editVideoRequest, locale.rename_video_success);
  };

  useEffect(() => {
    if (!pageIndex) return;

    if (searchKeyword) setSearchList([]);

    fetchData(
      pageSize,
      DEFAULT_PAGEINDEX,
      sortOrder,
      searchKeyword,
      filterTypes,
      searchFolderId,
      sortField,
    );
    // eslint-disable-next-line
  }, [pageSize, searchKeyword, filterTypes, sortOrder, sortField, refreshKey]);

  useEffect(() => {
    if (selectedThumbnails.length) {
      setSelectedFolders([]);
    }

    setIsShowContext(selectedThumbnails.length > 0);
    // eslint-disable-next-line
  }, [selectedThumbnails]);

  useEffect(() => {
    if (selectedFolders.length) {
      setSelectedThumbnails([]);
    }

    setIsShowFolderContext(selectedFolders.length > 0);
    // eslint-disable-next-line
  }, [selectedFolders]);

  useEffect(() => {
    if (isShowPlayer && videoUrl) {
      setIsShowPlayerScreen(true);
    }
  }, [isShowPlayer, videoUrl]);

  useEffect(() => {
    //Get videos in folder
    if (!isShowMoveDialog && !isShowMoveFolder && folderId !== null) {
      fetchFolderData(searchFolderId);
    }

    // eslint-disable-next-line
  }, [folderId]);

  useEffect(() => {
    //Delete & Move
    if (isDeleteSuccess) {
      fetchFolderData(folderId);
    } else if (isMoveSuccess) {
      fetchFolderData(previousFolderId);
    }

    // eslint-disable-next-line
  }, [isDeleteSuccess, isMoveSuccess]);

  return (
    <>
      {isShowPlayerScreen ? (
        <PlayerDialog
          url={videoUrl}
          onClose={() => onClose()}
          name={selectedThumbnails[0]?.name}
          onPlayerError={onPlayerError}
          onCopyLinks={() => onCopyLinks()}
          onDownload={() => onDownload()}
          onClickDetails={() => onClickDetails()}
          onClickEdit={() => onClickEdit()}
          onClickRename={() => onRenameVideo()}
        />
      ) : (
        <></>
      )}
      <TopAppBar
        nav={"main"}
        handleLogout={() => {}}
        setPageIndex={pageIndex}
      ></TopAppBar>

      <SideFolderContainer
        isClickedBreadCrumb={isClickedBreadCrumb}
        setIsClickedBreadCrumb={setIsClickedBreadCrumb}
        isClickedFolder={isClickedFolder}
      />
      <div
        style={{
          paddingLeft: "419px",
          paddingRight: "30px",
          height: "80vh",
          paddingTop: "148px",
          overflowY: "hidden",
        }}
      >
        <>
          {searchKeywordTemp.length > 1 ? (
            <>
              <SearchLabel />
              <Box display="flex">
                <SearchFilter label={locale.search_filter} />
                <SortFilter />
              </Box>
              {!isShowFolderContext && (
                <ContextMenu
                  isShow={isShowContext}
                  onClickPlay={() => onClickPlay()}
                  onDownload={() => onDownload()}
                  onClickDetails={() => onClickDetails()}
                  onCopyLinks={() => onCopyLinks()}
                  onClickEdit={() => onClickEdit()}
                  onClickRetag={() => setIsShowRetagDialog(true)}
                  onClickMove={() => setIsShowMoveDialog(true)}
                  onClickRename={() => onRenameVideo()}
                  onClickExport={() => {
                    (async () => {
                      const transcripts = await exportTranscript(
                        selectedThumbnails[0].videoIndexId,
                      );

                      if (!transcripts?.data || transcripts.data.length === 0) {
                        toast.error(
                      locale.transcript_export_error,
                          {
                            position: "bottom-left",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: false,
                            pauseOnFocusLoss: false,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                          },
                        );
                        return;
                      }

                      jsonToCsvExport({
                        data: transcripts.data,
                        filename: `${selectedThumbnails[0].name}.csv`,
                      });
                    })();
                  }}
                />
              )}
              {!isShowContext && isShowFolderContext && (
                <FolderContextMenu
                  isShow={isShowFolderContext}
                  onRename={() => onRenameFolder()}
                  onMove={() => setIsShowMoveFolder(true)}
                />
              )}
            </>
          ) : (
            <Grid item xs={12}>
              <Breadcrumb
                path={breadcrumbPath}
                onClick={(e: any) => setIsClickedBreadCrumb(e)}
              />
              {!isShowFolderContext && (
                <ContextMenu
                  isShow={isShowContext}
                  onClickPlay={() => onClickPlay()}
                  onDownload={() => onDownload()}
                  onClickDetails={() => onClickDetails()}
                  onCopyLinks={() => onCopyLinks()}
                  onClickEdit={() => onClickEdit()}
                  onClickRetag={() => setIsShowRetagDialog(true)}
                  onClickMove={() => setIsShowMoveDialog(true)}
                  onClickRename={() => onRenameVideo()}
                  onClickExport={() => {
                    (async () => {
                      const transcripts = await exportTranscript(
                        selectedThumbnails[0].videoIndexId,
                      );

                      if (!transcripts?.data || transcripts.data.length === 0) {
                        toast.error(
                      locale.transcript_export_error,
                          {
                            position: "bottom-left",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: false,
                            pauseOnFocusLoss: false,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                          },
                        );
                        return;
                      }

                      jsonToCsvExport({
                        data: transcripts.data,
                        filename: `${selectedThumbnails[0].name}.csv`,
                      });
                    })();
                  }}
                />
              )}
              {!isShowContext && isShowFolderContext && (
                <FolderContextMenu
                  isShow={isShowFolderContext}
                  onRename={() => onRenameFolder()}
                  onMove={() => setIsShowMoveFolder(true)}
                />
              )}
            </Grid>
          )}
          <div style={{ height: "calc(100vh - 380px)", overflowY: "scroll" }}>
            {isShowFolders && (
              <ScreenFolderContainer
                isClickedFolder={isClickedFolder}
                setIsClickedFolder={setIsClickedFolder}
              />
            )}
            {!isDataEmpty ? (
              <>
                <LabelText
                  text={locale.videos}
                  style={{
                    fontFamily: mainFont,
                    fontWeight: 600,
                    fontSize: "1.25rem",
                    lineHeight: "1.5rem",
                    color: black,
                  }}
                />

                {searchList.length > 0 ? (
                  <ThumbnailList
                    key={refreshKey}
                    items={searchList}
                    onClickPlay={onClickPlay}
                    onDownload={onDownload}
                    onClickDetails={onClickDetails}
                    onCopyLinks={onCopyLinks}
                    onClickEdit={onClickEdit}
                    onClickRetag={() => setIsShowRetagDialog(true)}
                    onClickMove={() => setIsShowMoveDialog(true)}
                  />
                ) : (
                  <Grid container spacing={{ xs: 2, md: 3, lg: 3 }}>
                    {skeletonItems.map((_, index) => (
                      <Grid item xs={12} sm={12} md={4} lg={4} key={index}>
                        <SkeletonThumbnailLoader />
                      </Grid>
                    ))}
                  </Grid>
                )}
              </>
            ) : (
              <BoxComponent body={locale.no_videos} />
            )}
          </div>
        </>
        {isShowFooter() && (
          <Footer marginLeft="345px" width="calc(100% - 419px)">
            <PageRecords
              records={totalRecords}
              pages={totalPages}
              selectedValue={selectedValue}
              onChangePageSize={onChangePageSize}
              defaultValue={DEFAULT_PAGE_SIZE}
            />
            <Pagination
              name={locale.goToPage}
              pages={totalPages}
              pageIndex={pageIndex}
              activePage={pageIndex}
              onChangePageRow={onChangePageRow}
              onChangePageIndex={onChangePageIndex}
              marginRight="2.5rem"
            />
          </Footer>
        )}
      </div>
      {isShowDeleteDialog && (
        <DialogBox
          header={locale.deleteHeader}
          body={<div>{locale.deleteBody}</div>}
          subBody={renderDeleteDialog()}
          onCancel={() => setIsShowDeleteDialog(false)}
          onSubmit={deleteVideos}
          isDelete
          primaryButton={locale.yes}
          secondaryButton={locale.no}
        />
      )}
      {isShowRetagDialog && (
        <DialogBox
          header={
            selectedThumbnails.length > 1
              ? locale.retag_header_multiple.replace(
                  "%d",
                  selectedThumbnails.length,
                )
              : locale.retag_header
          }
          body={<div>{locale.retag_description}</div>}
          subBody={renderRetagDialog()}
          onCancel={() => {
            setRetagValue("");
            setIsShowRetagDialog(false);
          }}
          onSubmit={onRetag}
          isDelete={false}
          primaryButton={locale.add}
          secondaryButton={locale.cancel}
        />
      )}
      {isShowMoveDialog && <MoveVideo />}

      {isShowRenameDialog ? (
        <DialogBox
          header={locale.control_rename}
          body={<></>}
          subBody={
            <div>
              <TextFieldInput
                value={tempVideoTitle}
                onChange={(e: any) => setTempVideoTitle(e.target.value)}
              />
            </div>
          }
          onCancel={() => {
            setTempVideoTitle(selectedThumbnails[0]?.name || "");
            setIsShowRenameDialog(false);
          }}
          onSubmit={() => onSubmitRename()}
          isDelete={false}
          primaryButton={locale.save}
          secondaryButton={locale.cancel}
          disablePrimary={
            tempVideoTitle.trim() === "" ||
            tempVideoTitle === selectedThumbnails[0]?.name
          }
        ></DialogBox>
      ) : (
        <></>
      )}
    </>
  );
};

export default MainScreen;
